import {  Toaster as ToasterComponent, ToastBar } from 'react-hot-toast';

function Toaster() {
  return (
    <ToasterComponent containerStyle={{marginTop:'58px'}}>
      {
        (t) => (
          <ToastBar   toast={t} />
          )
      }
    </ToasterComponent>
  );
}

export default Toaster;